(() => {
  class DosespotMedicationFinderController {
    constructor(Constants, MedicationService) {
      'ngInject';

      Object.assign(this, {
        MedicationService,
        DosespotDispenseUnits: Constants.DosespotDispenseUnits,
        medication: {}
      }); //console.log(this);
    }

    onMedicationSelect(medication) {
      if (!medication) {
        this.medication = {};
        this.onMedicationRemoved();
        return;
      } //console.log(medication);


      this.medication.name = medication.name;
      this.MedicationService.getDosespotMedicationStrengths(medication.name).then(({
        data
      }) => {
        this.medication.strengths = data.sort();
      });
    }

    onStrengthSelect() {
      if (!this.medication) {
        return;
      }

      const {
        name,
        strength
      } = this.medication;
      this.MedicationService.getDosespotMedicationRecord(name, strength).then(({
        data: medication
      }) => {
        //console.log(medication);
        this.medication = medication;
        this.onMedicationFound({
          medication
        });
      });
    }

    onDispenseUnitChange() {
      const unit = this.DosespotDispenseUnits.find(u => u.id === this.medication.dispense_unit_id);

      if (!unit) {
        return;
      }

      this.medication.dispense_unit_description = unit.name;
      this.medication.dose_form_description = unit.name.toLowerCase();
    }

  }

  DosespotMedicationFinderController.$inject = ["Constants", "MedicationService"];
  angular.module('pims').component('dosespotMedFinder', {
    templateUrl: 'app/components/dosespot-med-finder.html',
    controller: DosespotMedicationFinderController,
    bindings: {
      onMedicationRemoved: '&',
      onMedicationFound: '&'
    }
  });
})();